module.exports = __webpack_public_path__ + "img/coin_classic_copacked.69f3ad78.png";